import React from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { useNavigate } from 'react-router';
import { setToggleAuthSetting, setModalState, } from '../../actions/css'
import { 
  setHoverStateCu, setHoverState, 
  setHoverStateHt, setHoverStateHc, 
  setHoverStateLc 
} from '../../actions/css';
import {setOSCChannelState} from '../../actions/notifications';
import menuToggle from '../../images/icons/menuToggle.png';
// import paths from '../../helpers/paths';
import cart from '../../images/icons/cart.png';


const DashBoardTab = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { totalQuantity, } = useSelector(state => state.cart);
  // const { totalQuantity } = this.props.cart;
  const handleHoverShow = () => {
  dispatch(setHoverStateHt(false)); 
  dispatch(setHoverStateHc(false));  
  dispatch(setHoverStateLc(false));    
  dispatch(setHoverStateCu(false)); 
  dispatch(setHoverState(true));      
  };
  const handleHoverShowHT = () => {   
    dispatch(setHoverState(false)); 
    dispatch(setHoverStateHc(false));  
    dispatch(setHoverStateLc(false)); 
    dispatch(setHoverStateCu(false)); 
    dispatch(setHoverStateHt(true));      
  };
  const handleHoverShowHC = () => {   
    dispatch(setHoverState(false)); 
    dispatch(setHoverStateHt(false));   
    dispatch(setHoverStateLc(false)); 
    dispatch(setHoverStateCu(false)); 
    dispatch(setHoverStateHc(true));      
  };
  const handleHoverShowLC = () => {   
    dispatch(setHoverState(false)); 
    dispatch(setHoverStateHt(false));   
    dispatch(setHoverStateHc(false));
    dispatch(setHoverStateCu(false)); 
    dispatch(setHoverStateLc(true));     
  };
  const handleHoverShowCU = () => {   
    dispatch(setHoverState(false)); 
    dispatch(setHoverStateHt(false));   
    dispatch(setHoverStateHc(false));
    dispatch(setHoverStateLc(false));    
    dispatch(setHoverStateCu(true));  
  };
  const handleHoverHideIT = () => {   
    dispatch(setHoverState(false)); 
    dispatch(setHoverStateHt(false));   
    dispatch(setHoverStateHc(false)); 
    dispatch(setHoverStateCu(false));    
    dispatch(setHoverStateLc(false));  
  };
  return (
    <div onClick={() => {
      dispatch(setToggleAuthSetting(false));
    }} className='dashboard-tab-bs' id='dashboard-tab-bs'>
      <div className='dashboardtab-div1'>
        <img onClick={() => {
        dispatch(setModalState(true));
      }} src={menuToggle} alt='lifecarefront.com' title='lifecarefront.com'/>
        {/* <a ><i className="search-icon-image-sss fa fa-bars"></i></a> */}
      </div>
      <table className='dashboardtab-table' align="center">
        <tbody>
          <tr>
            <td className='dashboardtab-td'>
              <a href='#' className='tablink' onMouseEnter={handleHoverShow} 
                  onMouseLeave={handleHoverHideIT}>SHOP ALL <i className="fa fa-angle-down"></i></a>
            </td>
            <td className='dashboardtab-td'>
              <a href='#' className='tablink' onMouseEnter={handleHoverShowHT} 
                  onMouseLeave={handleHoverHideIT}>ON DEMAND <i className="fa fa-angle-down"></i></a>
            </td>
            <td className='dashboardtab-td'>
              <a href='#' className='tablink' onMouseEnter={handleHoverShowHC} 
              onMouseLeave={handleHoverHideIT}>RECOMMENDED <i className="fa fa-angle-down"></i></a>
            </td>
            <td onClick={() => {
              navigate("/dashboard");
              // history.push(paths.dashboard);
            }} className='dashboardtab-td-img'><img className='logo-image-banner' 
            // src={`https://res.cloudinary.com/daw8l0o1v/image/upload/v1598527302/shop/icons/f1c1d83d-9509-475d-9196-fd7e1ec51c0d_-_Copy_aa3guy.jpg`} 
              src={"../../images/Logo/lcfLogo.png"}
            alt='lifecarefront.com' title='Life Care'/></td>
            <td onClick={() => {
              navigate("/about");
              // history.push(paths.about);
            }} className='dashboardtab-td'><a href='#' className='tablink'>ABOUT US</a></td>
            <td className='dashboardtab-td'>
              <a href='#' className='tablink' onMouseEnter={handleHoverShowLC} 
                  onMouseLeave={handleHoverHideIT}>OUR LOCATIONS <i className="fa fa-angle-down"></i></a>
            </td>
            <td className='dashboardtab-td'>
              <a href='#' className='tablink' onMouseEnter={handleHoverShowCU} 
                  onMouseLeave={handleHoverHideIT}>CONTACT US <i className="fa fa-angle-down"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
      <div className='dashboardtab-div2'>
        <a onClick={() =>{
          dispatch(setOSCChannelState(true));
          // navigate("/shoppingcart");
          // history.push(paths.shoppingcart);
        }} className='mailListRef' href='#'><img className='giftIcon' src={cart} /> {`(${totalQuantity})`}</a>
      </div>
    </div>
  )
};


export default DashBoardTab;